export const TITLE = "OSM Rage+ 10.8 kwh Price in 2026 - Range, Specification & Reviews | Turno";
export const H1_HEADING = "OSM Rage Plus 10.8 kwh";
export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for OSM Rage Plus 10.8 kwh price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "OSM Rage Plus 10.8 kwh, OSM Rage+ 10.8 kwh, OSM electric vehicle, OSM electric cargo vehicle, OSM electric commercial vehicle, OSM Rage Plus 10.8 kwh price, OSM Rage Plus 10.8 kwh specifications, OSM Rage Plus 10.8 kwh range, OSM Rage Plus 10.8 kwh load capacity, OSM electric vehicle price, OSM commercial vehicle, OSM electric auto, OSM EV, OSM electric truck, OSM cargo vehicle, OSM electric vehicle specifications, OSM electric vehicle features, OSM electric vehicle reviews, OSM electric vehicle dealer, OSM electric three wheeler, OSM 10.8 kwh",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "OSM Rage+ 10.8 kwh Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for OSM Rage Plus 10.8 kwh price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for OSM Rage Plus 10.8 kwh price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "OSM Rage+ 10.8 kwh Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "OSM", href: "/electric-commercial-vehicles/OSM" },
  { label: "Rage+ 10.8 kwh" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "OSM",
      item: "https://www.turno.club/electric-commercial-vehicles/OSM",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Rage+ 10.8 kwh",
      item: VEHICLE_LINK,
    },
  ],
};
